import { Alert, Button, Group, Stack } from '@mantine/core';
import { IconAlertCircle, IconRefresh } from '@tabler/icons-react';
import { useTranslation } from 'react-i18next';

interface ErrorStateProps {
  error?: unknown;
  onRetry?: () => void;
  title?: string;
}

function describeError(err: unknown): string {
  if (!err) return '';
  if (err instanceof Error) return err.message;
  if (typeof err === 'string') return err;
  return JSON.stringify(err);
}

export function ErrorState({ error, onRetry, title }: ErrorStateProps) {
  const { t } = useTranslation('errors');
  return (
    <Alert
      color="red"
      variant="light"
      icon={<IconAlertCircle size={20} />}
      title={title ?? t('generic')}
      role="alert"
    >
      <Stack gap="xs">
        <span>{describeError(error)}</span>
        {onRetry ? (
          <Group>
            <Button
              size="xs"
              variant="outline"
              leftSection={<IconRefresh size={14} />}
              onClick={onRetry}
            >
              {t('boundary.reload')}
            </Button>
          </Group>
        ) : null}
      </Stack>
    </Alert>
  );
}
